import { useEffect } from 'react';
import { usePlayerStore } from '@/store/playerStore';
import { Sparkles } from 'lucide-react';

/**
 * Non-blocking Smart Tune notification toast.
 * Auto-dismisses after a few seconds.
 */
export function SmartTuneToast() {
  const message = usePlayerStore((s) => s.smartTuneMessage);
  const clear = usePlayerStore((s) => s.setSmartTuneMessage);

  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => clear(null), 4500);
    return () => clearTimeout(t);
  }, [message, clear]);

  if (!message) return null;

  return (
    <div className="pointer-events-none absolute inset-x-0 top-16 z-40 flex justify-center px-4 sm:top-20">
      <div className="pointer-events-auto flex items-center gap-2 rounded-full glass-strong px-4 py-2 text-xs text-slate-200 shadow-glow animate-signal-pulse">
        <Sparkles className="h-3.5 w-3.5 text-accent-400" />
        {message}
      </div>
    </div>
  );
}
